import { createBasicSelector } from 'util/redux'
import { selectBase } from './selectBase'

export const selectBillingProvider = createBasicSelector(
  selectBase,
  base => base.provider || 'stripe'
)
